import { ApiContext } from '../../types';

export const isSSR = ({ flowAPI }: ApiContext): boolean => {
  return (
    flowAPI?.controllerConfig?.wixCodeApi?.window?.rendering?.env === 'backend'
  );
};
